<template>
    
	<div>
			<div class="formsBox" id="formsBox1" v-if="showSoftware">
				<h2>软件产品体验</h2>			
				<div class="formsContent">
					<el-form :model="formSoftware" ref="formSoftware" label-width="100px">
						<el-form-item label="姓名" prop="name">
							<el-input v-model="formSoftware.name" placeholder="请输入名字"></el-input>
						</el-form-item>
						<el-form-item label="电话" prop="phone">
							<el-input v-model="formSoftware.phone" placeholder="请输入手机号"></el-input>
						</el-form-item>
						<el-form-item label="验证码" prop="code" class="codeBox">
							<el-input v-model="formSoftware.code">
							</el-input>
							<img src="../../src/img/sx.png" alt="" class="sxBtn" @click="replace()">
							<img :src="codeUrl" alt="" class="codeImg">
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="submitForm('formSoftware')">提交</el-button>
							<el-button @click="resetForm('formSoftware')">重置</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="formsBox" id="formsBox2" v-if="showInvestors">
				<h2>投资者联系</h2>			
				<div class="formsContent">
					<el-form :model="formInvestors" ref="formInvestors" label-width="100px">
						<el-form-item label="姓名" prop="name">
							<el-input v-model="formInvestors.name" placeholder="请输入姓名"></el-input>
						</el-form-item>
						<el-form-item label="公司名称" prop="company">
							<el-input v-model="formInvestors.company" placeholder="请输入公司名称"></el-input>
						</el-form-item>
						<el-form-item label="职位" prop="position">
							<el-input v-model="formInvestors.position" placeholder="请输入职位"></el-input>
						</el-form-item>
						<el-form-item label="邮箱" prop="email">
							<el-input v-model="formInvestors.email" placeholder="请输入正确邮箱"></el-input>
						</el-form-item>
						<!-- <el-form-item label="类型" prop="type">
							<el-select v-model="formInvestors.type" placeholder="- 请选择 -">
								<el-option label="区域一" value="shanghai"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="内容" prop="content">
							<el-input type="textarea" v-model="formInvestors.content" placeholder="请输入内容"></el-input>
						</el-form-item> -->
						<el-form-item label="验证码" prop="code" class="codeBox">
							<el-input v-model="formInvestors.code">
							</el-input>
							<img src="../../src/img/sx.png" alt="" class="sxBtn" @click="replace()">
							<img :src="codeUrl" alt="" class="codeImg">
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="submitForm('formInvestors')">提交</el-button>
							<el-button @click="resetForm('formInvestors')">重置</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
	</div>
</template>
<style scoped>
</style>
<script>
import * as axios from '../../src/axios/api.js'
export default{
	data(){
		return{
			formSoftware: {
				name: '',
				phone: '',
				code: ''
			},
			formInvestors: {
				name: '',
				company: '',
				position:'',
				email:'',
				type:'',
				content:'',
				code: ''
			},
			codeUrl:'/api/verify_code/captcha',
			showInvestors:false,
			showSoftware:false
		}
	},
    mounted() {
		if(this.$route.query.formBox==2){
			this.showSoftware = false;
			this.showInvestors = true;  
		}else{
			this.showSoftware = true;
			this.showInvestors = false;
		}
		// window.addEventListener('scroll', this.handleScroll)
		},
	watch: {	
		$route(to) {
			if(this.$route.query.formBox==1 ||this.$route.query.formBox == undefined){
				this.showSoftware = true;
				this.showInvestors = false;    
			}else{
				this.showSoftware = false;
				this.showInvestors = true;
			}
		}
	},         
	methods:{
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		replace() {
			this.codeUrl = '/api/verify_code/captcha?num=' + Math.random()
		},
		submitForm(formName){
			if(formName==='formSoftware'){
				axios.post('/api/product/experience',this.formSoftware).then(res => {
					if(res.code==1){
						this.$message({
						  message: res.msg,
						  type: 'success',
						  offset:60,
						});
					}
					this.replace();
				});
			}else{
				axios.post('/api/contact/addComment',this.formInvestors).then(res => {
					if(res.code==1){
						this.$message({
						  message: res.msg,
						  type: 'success',
						  offset:60,
						});
					}
					this.replace();
				});
			}
			
		}
	}
}
</script>
<style scoped>
 .el-select{width:100%;}
 /deep/.el-form-item__label {color: #333;font-weight: bold;}
 /deep/.codeBox .el-input{width: 300px;vertical-align: middle;}
 .sxBtn{position: absolute;left: 270px;width: 22px;height: 19px;top: 10px;}
 .codeImg{width:99px;height: 38px;display:inline-block;vertical-align: middle;margin-left: 20px;}
/deep/.el-message .el-message--warning .is-center{top:100px!important;z-index:1000000!important;}
</style>

